export enum DomainList {
  BENU = "benu",
  BENUDE = "benude",
  CLEVER = "clever",
  BESTATTUNGSINFO = "bestattungsinfo",
  DIEBAUMBESTATTUNG = "diebaumbestattung",
}
